import { register } from 'tmr/tmr/ngModuleRegistry'

import * as checklistNavBar from './checklistNavBar/checklistNavBar'
import * as configurationNavBar from './configurationNavBar/configurationNavBar'
import * as hierarchiesNavBar from './hierarchiesNavBar/hierarchiesNavBar'
import * as movementNavBar from './movementNavBar/movementNavBar'
import * as navBar from './navBar'
import * as printNavBar from './printNavBar/printNavBar'
import * as productionOrderNavBar from './productionOrderNavBar/productionOrderNavBar'
import * as roleNavBar from './roleNavBar/roleNavBar'

export default register(
  'tmr.core.components.navbars',
  checklistNavBar,
  configurationNavBar,
  hierarchiesNavBar,
  movementNavBar,
  navBar,
  printNavBar,
  productionOrderNavBar,
  roleNavBar
)
